import React from "react";

export default function HeaderFooterPage() {

    return (
        <>
        <footer>
                <p>&copy; Copyright 2026 - All Rights Reserved</p>
        </footer>
        </>
);
}
